export const defaultValue = <T, U>(value: T, fallback: U) =>
	value ?? fallback;

export default {};
